module.exports = __webpack_public_path__ + "static/img/star.67a44e9e.png";